import script from "./DrawerAccordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawerAccordion.vue?vue&type=script&setup=true&lang=ts"

import "./DrawerAccordion.vue?vue&type=style&index=0&id=3eed4811&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eed4811"]])

export default __exports__